import Effects from 'Effects';
import Tone from 'tone';
import {AudioParamPercentageValueParameter,
        AudioParamValueParameter} from 'parameters/AbstractAudioParamParameter.js';

class StereoWidener extends Effects.Effect {

    constructor(sequencerEngine) {
        super('Stereo Widener', () => new Tone.StereoWidener(0.5), sequencerEngine); 
        this.widthParameter = new AudioParamValueParameter(
            'Width', this.effectNode.width, {
                min: 0,
                max: 1,
                defaultValue: 0.5
            });
        this.registerParameter(this.widthParameter);
        this.updateInitialValues();
    }

    getJson() {
        let json = super.getJson();
        json.width = this.widthParameter.get();
        json = this.saveParameterToJson(json, 'widthParameter', this.widthParameter);
        return json;
    }

    fromJson(json, isCopy) {
        super.fromJson(json, isCopy);

        this.widthParameter.set(json.width);

        this.loadParameterFromJson(json, 'widthParameter', this.widthParameter, isCopy);
    }

    getEffectCopy(sequencerEngine=this.sequencerEngine, ignoreId=true) {
        var copy = new StereoWidener(sequencerEngine);
        copy.fromJson(this.getJson(), ignoreId);
        return copy;
    }
}

export default StereoWidener;
